import { createApiOperation } from "../api-client/create-api-operation";

import { Substitutions } from "./types/substitutions";

export const SubstitutionsApi = {
  list: createApiOperation<
    Substitutions,
    "/Api/Substitutions/{datasetId}",
    "get"
  >("/Api/Substitutions/{datasetId}", "get"),

  create: createApiOperation<never, "/Api/Substitutions/{datasetId}", "post">(
    "/Api/Substitutions/{datasetId}",
    "post",
  ),

  update: createApiOperation<
    never,
    "/Api/Substitutions/{datasetId}/{substitutionId}",
    "put"
  >("/Api/Substitutions/{datasetId}/{substitutionId}", "put"),

  delete: createApiOperation<
    never,
    "/Api/Substitutions/{datasetId}/{substitutionId}",
    "delete"
  >("/Api/Substitutions/{datasetId}/{substitutionId}", "delete"),
};
